import { useState, useRef } from 'react';

import { Modal } from 'antd';

const useModalCloseConfirm = (props?: any) => {
  const { confirmText } = props || {};
  const [visible, setVisible] = useState(false);
  const isEdited = useRef(false);
  const onOpen = (data?: any) => {
    const { callback } = data || {};
    if (callback) {
      callback();
    }
    setVisible(true);
  }

  const onEdited = () => {
    isEdited.current = true;
  }

  const commonClose = () => {
    setVisible(false);
    isEdited.current = false;
  }

  const resetEditFlag = () => {
    isEdited.current = false;
  }

  const onClose = (data?: any) => {
    const { callback } = data || {};

    if (isEdited.current) {
      Modal.confirm({
        title: confirmText || '当前页面信息未保存，确认关闭吗？',
        cancelText: '取消',
        okText: '确认',
        onOk() {
          commonClose();
          if (callback) {
            callback();
          }
        },
        onCancel() {},
      })
    } else {
      if (callback) {
        callback();
        commonClose();
      }
    }
  }

  const onOk = (data?: any) => {
    const { callback } = data || {};
    if (callback) {
      callback(commonClose);
    } else {
      commonClose();
    }
  }

  return {
    visible,
    onOpen,
    onClose,
    onOk,
    onEdited,
    resetEditFlag
  }
}

export default useModalCloseConfirm;
